// extracted by mini-css-extract-plugin
export var buttons = "_a7-0";
export var buttonsActive = "_a7-h";
export var cancelConfirm = "_a7-1";
export var closeButton = "_a7-2";
export var column = "_a7-3";
export var container = "_a7-4";
export var detailHeader = "_a7-6";
export var detailTitle = "_a7-7";
export var detailsContent = "_a7-5";
export var header = "_a7-8";
export var headerWithClose = "_a7-9";
export var icon = "_a7-a";
export var infoIcon = "_a7-c";
export var informationContainer = "_a7-b";
export var sideDrawer = "_a7-d";
export var sideDrawerOpen = "_a7-e";
export var stickyFooter = "_a7-f";
export var typeOption = "_a7-g";